import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  contentDialog: {
    // maxHeight: 'calc(100vh - 64px)',
    maxHeight: '90vh',

    // maxHeight: ''
    // maxHeight: 1150,
    // minHeight: 1150,
  },
}));

export default useStyles;
